<template>
  <div class="col-12" :class="{ 'px-0 px-sm-3': seleccionada }">
    <div class="content-box" :class="{ 'px-0 px-sm-4': seleccionada }">
      <div class="support-index" :class="{ 'show-ticket-content': seleccionada, 'full-layout-content': seleccionada && facturasFiltradas.length === 0 }">
        <div class="support-tickets">

          <div class="d-flex justify-content-between mb-4">
            <router-link class="btn btn-sm btn-outline-danger back-to-index radius_custom py-2" :to="{ name: 'wms-recepcion', params: {} }">
              <i class="fas fa-angle-double-left"></i>&nbsp;
              <span>Listado</span>
            </router-link>
            <div class="d-block text-center">
              <div class="badge badge-danger p-2 radius_custom pulse-red" v-if="current.estado == '9'">
                Anulada
              </div>
              <div class="badge badge-success p-2 radius_custom pulse-green" v-if="current.estado == 'A'">
                Abierta
              </div>
              <div class="badge badge-secondary p-2 radius_custom pulse-secondary" v-if="current.estado == 'C'">
                Finalizada
              </div>
            </div>
          </div>
          
          <div class="row">
            

            <div class="col-12 justify-content-between mb-2">
              <div class="element-box white_gradient_bg_light shadow_inset_lg">

                <div class="row mx-2 mb-2 py-1 align-items-center">
                  <div class="col-md-8 col-12 text-center text-md-left px-0">
                    <h5 v-if="current.tienda_obj" class="text-success mb-0">
                      {{ current.tienda_obj.nombre }}
                    </h5>
                  </div>
                </div>
                <div>
                  <h6 class="mx-2">Recepción #{{ current.numero }}</h6>

                  <div class="tickets-filter mx-2">
                    <div class="ae-item with-status status-green">
                      <div class="aei-content">
                        <div v-if="current.proveedor_obj" class="aei-title">
                          {{ current.proveedor_obj.codigo }} -
                          {{ current.proveedor_obj.nombre }}
                        </div>
                        <div v-if="current.proveedor_obj" class="aei-title">
                          Nit: <b>{{ current.proveedor_obj.nit }}</b>
                        </div>
                      </div>
                      <div class="aei-content" v-if="current.estacion_descarga != null">
                        Estación: <b>{{ current.estacion_descarga_obj.posicion }}</b>
                      </div>
                      <div class="aei-content" v-if="current.estacion_descarga == null">
                        Estación: <b>Sin Estación Asignada</b>
                      </div>
                    </div>
                    <br>
                  </div>
                  
                  <div class="d-flex justify-content-between mx-3 mb-1 mt-2">
                    <!-- Incio Reportes -->
                    <div class="w-50 pr-1">
                      <div class="btn-group w-100">
                        <button aria-expanded="false" aria-haspopup="true" class="custom-btn btn btn-secondary dropdown-toggle w-100 py-2"
                          data-toggle="dropdown" type="button">
                          <i class="fa fa-print"></i>
                          Impresiones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button class="dropdown-item pb-3" v-if="current.estado == 'A'" data-target="#modalCrearEtiqueta"
                            data-toggle="modal" type="button">
                            <i class="fas fa-tag"></i>&nbsp;
                            Etiquetas
                          </button>
                          <button class="dropdown-item pb-3" type="button" v-if="current.estado == 'C'"
                            @click="reporteDiferencia(current)">
                            <i class="fas fa-coins"></i>&nbsp;
                            Diferencia Precios
                          </button>
                          <button class="dropdown-item pb-3" type="button" @click="reporteDevolucionMedia(current)"
                            v-if="current.estado !== '9'">&nbsp;
                            <i class="fas fa-file"></i>
                            Reporte Facturas Formato Pequeño
                          </button>
                          <button class="dropdown-item pb-3" type="button" @click="reporteDevolucion(current)"
                            v-if="current.estado !== '9'">&nbsp;
                            <i class="fas fa-file"></i>
                            Reporte Facturas Formato Grande
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Fin Reportes -->

                    <!-- Inicio Acciones -->
                    <div class="w-50 pl-1">
                      <div class="btn-group w-100">
                        <button :disabled="!isDetallesOCCargados" aria-expanded="false" aria-haspopup="true" class="custom-btn btn btn-secondary dropdown-toggle w-100 py-2"
                          data-toggle="dropdown" type="button">
                          <i class="fa fa-cogs"></i>&nbsp;&nbsp;
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button class="dropdown-item pb-3" v-if="current.estado == 'A'" @click="finalizarRecepcion"
                            type="button">
                            <i class="fas fa-clipboard-check"></i>&nbsp;
                            Finalizar Recepción
                          </button>
                          <button class="dropdown-item pb-3" type="button" data-toggle="modal"
                            data-target="#staticNotificacionProveedor" v-if="current.estado === 'C'"
                            @click="refreshContactosNotificacion">
                            <i class="fas fa-envelope"></i>&nbsp;
                            Notificar Proveedor
                          </button>
                          <hr></hr>
                          <button 
                            v-if="current.estado == 'A'"
                            class="dropdown-item pb-3" 
                            type="button" 
                            @click="añadirOrdenCompra()"
                          >
                            <i class="fas fa-file-alt"></i>&nbsp; Añadir OC
                          </button>
                          <button class="dropdown-item pb-3" v-if="current.estado === 'A'"
                            @click="clickRefetchDetallesOC">
                            <i class="fas fa-sync"></i>&nbsp;
                            Actualizar Data de OCs
                          </button>
                          <div v-if="current.estacion_descarga == null">
                            <button class="dropdown-item pb-3" type="button" data-toggle="modal" @click="abrirModalAsignarEncargadoProveedor">
                              <i class="fas fa-truck"></i>&nbsp; Asignar Encargado Proveedor
                            </button>
                          </div>
                          <div v-if="current.estacion_descarga == null">
                            <button class="dropdown-item pb-3" type="button" data-toggle="modal" @click="abrirModalAsignarEstacion">
                              <i class="fas fa-map-marker-alt"></i>&nbsp; Asignar Estación
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Fin Acciones -->
                  </div>
                </div>


              </div>
            </div>
          </div>


          <div class="support-tickets-header ">
            <!-- inicio filtros -->
            <br>
            <div class="col-12">
              <h5 v-if="tipo == 'FACTURAS'">Facturas en Recepción</h5>
              <br v-if="tipo == 'FACTURAS'" />
              <h5 v-if="tipo == 'BULTOS'">Bultos</h5>
              <br v-if="tipo == 'BULTOS'" />
            </div>
            <div class="col-12 element-box white_gradient_bg_light shadow_inset_lg">
                <div class="d-flex flex-wrap align-items-center">
                  <div class="d-flex justify-content-between w-100">
                    <div class="w-50 pr-1">
                      <label class="mr-2 mb-0">Tipo</label>
                      <div class="form-group mb-2 d-flex align-items-center">
                        <select class="form-control-sm flex-grow-1 w-100 custom-input shadow_inset_sm" v-model="tipo">
                          <option value="FACTURAS">Facturas</option>
                          <option value="BULTOS">Bultos</option>
                        </select>
                      </div>
                    </div>
                    <div class="w-50">
                      <label class="mr-2 mb-0">Status</label>
                      <div class="form-group mb-2 d-flex align-items-center">
                        <select class="form-control-sm flex-grow-1 w-100 custom-input shadow_inset_sm" v-model="estado">
                          <option value="">Todos</option>
                          <option value="A">Abierta</option>
                          <option value="B">Cerrada</option>
                          <option value="C">Finalizada</option>
                          <option value="9">Anulada</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-if="current.estado == 'A'" class="mb-2 mt-2 w-100 w-md-auto">
                    <button :disabled="!isDetallesOCCargados" class="btn btn-outline-success radius_custom_green btn-block py-3" 
                      @click="handleAgregarFactura" type="button">
                      Agregar Factura
                    </button>
                    <small v-if="!isTransporteValidado" class="d-block text-warning mt-1">
                      <i class="fas fa-exclamation-triangle"></i>
                      Asigna el encargado del proveedor o el transporte tercerizado primero.
                    </small>
                  </div>
                </div>
            </div>
            <!-- Fin Filtros -->
          </div>



          
          <div v-if="tipo == 'FACTURAS'" class="mt-0 pt-0">
            <RecepcionFacturaTicketComponent v-for="facturae in facturasFiltradas" :key="facturae.id"
              :facturae="facturae" @seleccion="seleccionar" />
          </div>
          
          <br />
          <div v-if="isDataLoaded" class="col-12">
              <div>
                <br />
                <h5>Órdenes de Compra Asignadas</h5>
                <div>
                  <div v-for="(card, index) in cards" :key="index" class="card mt-3 px-0 mx-0 support-ticket border-0 white_gradient_bg_light shadow_inset_lg">
                    <div class="card-header py-2 shadow" :id="'heading' + index">
                          <button 
                            class="btn btn-block btn-link decorator ticket-title" 
                            type="button" 
                            @click="resolveRouteOC('compras-ordencompra-editar', {
                              id: card.orden_compra.id,
                              backToReception: true
                            })">
                            OC #{{ card.orden_compra.numero }}
                            
                            <span v-if="card.orden_compra.vencida === false" :class="{
                              'badge badge-success':card.orden_compra.estado === 'B',
                              'badge badge-secondary':card.orden_compra.estado === 'D'
                              }" >
                              {{ estadoOrden(card.orden_compra) }}
                            </span>
                            <span v-else class="badge badge-danger">
                              {{ estadoOrden(card.orden_compra) }}
                            </span>
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        
        <div class="support-ticket-content-w white_gradient_bg_light shadow_inset_lg" v-if="seleccionada" style="min-width: 0;">

          
          <div class="px-0 px-lg-3 my-3 w-100" style="min-width: 0;">
            <div class="support-ticket-content-header mb-0">

              <div class="d-flex justify-content-between mb-4">
                <button class="btn btn-sm btn-outline-danger back-to-index radius_custom" @click="seleccionada = null">
                  <i class="fas fa-angle-double-left"></i>&nbsp;
                  <span>Volver</span>
                </button>
                <div class="element-actions">
                  <div class="btn-group">
                    <button :disabled="!isDetallesOCCargados" aria-expanded="false" aria-haspopup="true" class="py-2 btn btn-secondary dropdown-toggle radius_custom"
                      data-toggle="dropdown" type="button">
                      <i class="fa fa-cogs"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right ">
                      <button class="dropdown-item pb-3" @click="clickSincronizarPreciosOC()" :disabled="seleccionada.estado != 'A'"
                        data-toggle="modal" type="button">
                        <i class="fas fa-hand-holding-usd"></i>
                        Actualizar Precios Factura 
                      </button>
                      <button class="dropdown-item pb-3" @click="openModalEditarFact" :disabled="seleccionada.estado != 'A'"
                        data-toggle="modal" type="button">
                        <i class="far fa-edit"></i>
                        Editar Factura
                      </button>
                      <button class="dropdown-item pb-3" type="button" @click="cerrarFactura"
                        :disabled="seleccionada.estado != 'A'">
                        <i class="fas fa-folder"></i>
                        Cerrar Factura
                      </button>
                      <button class="dropdown-item pb-3" type="button" @click="abrirFactura"
                        :disabled="seleccionada.estado != 'B'">
                        <i class="fas fa-folder-open"></i>
                        Abrir Factura
                      </button>
                      <button class="dropdown-item pb-3" type="button" @click="anular"
                        :disabled="seleccionada.estado == 'C' || seleccionada.estado == '9'">
                        <i class="fas fa-file-excel"></i>
                        anular Factura
                      </button>
                      <button v-if="!seleccionada.archivo && !seleccionada.archivo_2" class="dropdown-item pb-3" type="button" data-toggle="modal"
                        data-target="#subirfactura">
                        <i class="fas fa-cloud-upload-alt"></i>
                        Subir Factura Escaneada
                      </button>
                      <button v-if="seleccionada.archivo || seleccionada.archivo_2" class="dropdown-item pb-3" type="button" data-toggle="modal"
                        data-target="#subirfactura">
                        <i class="fa fa-retweet"></i>
                        Cambiar Factura Escaneada
                      </button>
                      <button class="dropdown-item pb-3" type="button" data-toggle="modal" data-target="#referenciaModal">
                        <i class="fa fa-quote-left"></i>
                        Agregar Referencia
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <hr>
              <div style="text-align: center">
                <div class="d-flex justify-content-between gap-0">
                  <h4>Serie</h4>
                  <div class="d-block text-center">
                    <div class="badge badge-danger p-2 radius_custom pulse-red" v-if="seleccionada.estado == '9'">
                      Anulada
                    </div>
                    <div class="badge badge-success p-2 radius_custom pulse-green" v-if="seleccionada.estado == 'A'">
                      Abierta
                    </div>
                    <div class="badge badge-secondary p-2 radius_custom pulse-secondary" v-if="seleccionada.estado == 'B'">
                      Cerrada
                    </div>
                    <div class="badge badge-dark p-2 radius_custom pulse-dark" v-if="seleccionada.estado == 'C'">
                      Finalizada
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <h5 class="font-weight-light mx-3">{{ seleccionada.serie }}</h5>
                </div>
                <div class="d-flex justify-content-between gap-0">
                  <h4>Factura</h4>
                  <div class="d-block text-center">
                    <h4>Fecha</h4>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <h5 class="font-weight-light mx-3">#{{ seleccionada.documento }}</h5>
                  <div class="d-block text-center">
                    <h5 class="font-weight-light">{{ seleccionada.fecha_documento }}</h5>
                  </div>
                </div>

              </div>
              <br />
              
              <div>
                <div class="row mb-4">
                  <div class="col-12 col-md-6">
                    <div class="border_panel_green white_gradient_bg_light shadow_inset_lg mb-3 w-100">
                      <div class="row px-3 mx-2 align-items-center">
                        <div class="col-12 p-0">
                          <div class="py-3 mx-3">
                            <div class="ticket-content">
                              <div class="text-right align-items-center mb-1">
                                <h6 class="ticket-title m-0">
                                  Total Factura
                                </h6>
                              </div>
                              <div class="d-flex justify-content-between mt-2">
                                <div class="text-right w-100">
                                  <div style="font-size: 25px;">
                                    <b>Q.</b><span class="value text-success font-weight-bold">
                                      <AnimatedNumberComponent :value="Number(seleccionada.total_documento || 0)" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="white_gradient_bg_light shadow_inset_lg mb-3 w-100" :class="isInvoiceValid ? 'border_panel_green' : 'border_panel_red'">
                      <div class="row px-3 mx-2 align-items-center">
                        <div class="col-12 p-0">
                          <div class="py-3 mx-3">
                            <div class="ticket-content">
                              <div class="text-right align-items-center mb-1">
                                <h6 class="ticket-title m-0">
                                  Total Conteo
                                </h6>
                              </div>
                              <div class="d-flex justify-content-between mt-2">
                                <div class="text-right w-100">
                                  <div style="font-size: 25px;">
                                    <b>Q.</b><span class="value text-success font-weight-bold">
                                      <AnimatedNumberComponent :value="Number(totalConteoFrontend || 0)" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="d-flex justify-content-right gap-0">
                  <h5>Recepción</h5>
                </div>
                <div style="margin-bottom: -8px;" class="d-flex justify-content-right gap-0">
                  <div class="d-block text-left">
                    <span style="font-size: 15px;" class="font-weight-light mx-3">#{{ current.numero }}</span>
                  </div>
                </div>
                <br />
                <div class="d-flex justify-content-right gap-0">
                  <h5>Proveedor</h5>
                </div>
                <div class="d-flex justify-content-right gap-0">
                  <div class="d-block text-left">
                    <span style="font-size: 15px;" class="font-weight-light mx-3">{{ seleccionada.proveedor_obj.codigo }} - {{ seleccionada.proveedor_obj.nombre }} ({{ seleccionada.proveedor_obj.nit }})</span>
                  </div>
                </div>
                <br />
                
                <div style="text-align: right">
                  <button v-if="tieneArchivos" data-target="#modalVerArchivos" data-toggle="modal"
                    class="btn btn-secondary btn-sm">Archivos Subidos <i class="fas fa-eye"></i></button>
                  <span v-if="!tieneArchivos" class="btn badge badge-warning" data-toggle="modal"
                    data-target="#subirfactura">Sin Archivo Escaneado <i class="fas fa-unlink"></i></span>
                  &nbsp;&nbsp;
                  <button @click="refreshAll()" class="btn btn-sm btn-info">
                    Actualizar <i class="fas fa-sync"></i>
                  </button>
                </div>

              </div>
              <div class="badge badge-danger" v-if="current.estado == '9'">
                Recepción Anulada
              </div>
            </div>
            <RecepcionFacturaDetalleComponent :facturae="seleccionada" :recepcion="current" :isDetallesOCCargados="isDetallesOCCargados" @seleccion="seleccionar" />
          </div>


        </div>
      </div>
    </div>





    <!-- INICIO MODAL NOTIFICACION PARA CONTACTOS DE PROVEEDOR-->
    <div class="modal fade" id="staticNotificacionProveedor" tabindex="-1"
      aria-labelledby="staticNotificacionProveedorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="staticNotificacionProveedorLabel">Seleccione los contactos</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Contactos por Recepción de Mercancías de {{ nombreProveedor }}</p>
            <div :class="{ 'loader-wrapper': !contactos_cargados }">
              <LoaderComponent :condicion="contactos_cargados"></LoaderComponent>
              <div class="table-responsive" v-if="contactos_cargados">
                <table>
                  <tr>
                    <th colspan="2">Contactos por notificar</th>
                  </tr>
                  <tr>
                    <th class="text-center" colspan="2">Correo</th>
                  </tr>
                  <tr v-if="contactos.contactos_sin_notificar.length === 0">
                    <td colspan="2">No hay contactos por notificar</td>
                  </tr>
                  <tr v-for="contacto in contactos.contactos_sin_notificar" :key="contacto.correo">
                    <td>
                      <input @change="refreshContactosNotificacion" type="checkbox" name="contactos_seleccionados"
                        :value="contacto.correo" :checked="contacto.seleccionado">
                    </td>
                    <td>
                      {{ contacto.correo }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="table-responsive" v-if="contactos_cargados">
                <table>
                  <tr>
                    <th colspan="3">Contactos notificados</th>
                  </tr>
                  <tr>
                    <th class="text-center" colspan="2">Correo</th>
                    <th class="text-center" colspan="1">Fecha de envío</th>
                  </tr>
                  <tr v-if="contactos.contactos_notificados.length === 0">
                    <td colspan="2">Aún no hay contactos notificados</td>
                  </tr>
                  <tr v-for="contacto in contactos.contactos_notificados">
                    <td>
                      <input @change="refreshContactosNotificacion" type="checkbox" name="contactos_seleccionados"
                        :value="contacto.correo" :checked="contacto.seleccionado">
                    </td>
                    <td>
                      {{ contacto.correo }}
                    </td>
                    <td>
                      {{ contacto.fecha_envio | moment("DD/MM/YYYY HH:mm") }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <small style="color: gray" class="font-weight-bold">
              Tomar en cuenta lo siguiente:
              <br>
              <i style="color: gray" class="fas fa-info-circle"></i>
              Contactos por notificar son los contactos que aún no han sido notificados.
              <br>
              <i style="color: gray" class="fas fa-info-circle"></i>
              Contactos notificados son los que ya fueron notificados al menos una vez.
              <br>
              <i style="color: gray" class="fas fa-info-circle"></i>
              Debe marcar únicamente a los que desee notificar o reenviar el correo.
            </small>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-outline-info" data-target="#contactosProveedorModal"
              data-toggle="modal">
              Ver Contactos
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click="vistaPreviaCorreo" data-toggle="modal">
              Notificar
            </button>
            <button class="btn btn-sm btn-dark" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN DEL MODAL PARA NOTIFICACION DE CONTACTOS DE PROVEEDOR -->
     
    <!-- Inicia Modal ContactosProveedor -->
    <div class="modal fade" id="contactosProveedorModal" tabindex="-1" aria-labelledby="contactosProveedorModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="contactosProveedorModalLabel">Lista de contactos para el proveedor {{
              nombreProveedor }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ContactoProveedorTable :id_proveedor=current.proveedor />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-dark" ref="cerrarModal" data-dismiss="modal" type="button"
              @click="refreshContactosNotificacion">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modal añadir órdenes de compra -->
    <div class="modal fade" id="modalAddOC" tabindex="-1" role="dialog" aria-labelledby="addOrdenCompraModal"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="addOrdenCompraModal">Órdenes de compra</h5>
            <button type="button" class="btn btn-danger" @click="cancelAddOC()"><i class="fas fa-times"></i></button>
          </div>

            <div class="col-12">
            <div v-if="isDataLoaded && current.eventoAgenda" class="col-12">
              <b>Evento:</b>
              <br>
              <b>{{ current.proveedor_obj.id }} - {{ current.proveedor_obj.nombre }}</b>
              <br>
              <b>{{ current.eventoAgenda.fecha_de | moment("hh:mm a") }} - {{current.eventoAgenda.fecha_a | moment("hh:mm a") }}
              </b>
            </div>
          </div>

          <div class="modal-body">
            
            <div class="input-group mb-3">
              <input 
                type="text" 
                class="form-control" 
                placeholder="# Orden de Compra" 
                v-model="orderCompraNumber"
                @keypress="onlyNumbers"
              >
              <div class="input-group-append">
                <button class="btn btn-dark" type="button" @click="buscarOrdenCompra()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>

            <div v-if="ordenesCompra.length">
              <div v-for="orden in ordenesCompra" class="row ordencompra-table">
                <div class="col-12">
                  <div class="card" style="background-color: #eaf3fc;">
                    <div class="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <b class="card-title" style="font-size: 18px;">
                          #{{ orden.numero }}
                        </b>
                        <br>
                        <b style="font-size: 14px;">
                          {{ orden.proveedor.nombre }}
                        </b>
                        <p class="card-text">Tienda: {{ orden.tienda.nombre }}</p>
                        <p class="card-text">Fecha: {{ orden.fecha }}</p>
                      </div>
                      <button class="btn btn-dark btn-lg" @click="agregarOrdenCompra(orden)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isDataLoaded && current.eventoAgenda && Array.isArray(current.eventoAgenda.apl_agenda_orden_compra)">
              <hr>
              <h6>Órdenes de compra añadidas: {{ current.eventoAgenda.apl_agenda_orden_compra.length }}</h6>
              <div :class="{ 'anadidos-table': isDataLoaded, 'anadidos-table loader-wrapper': !isDataLoaded, }">
                <LoaderComponent :condicion="isDataLoaded">
                </LoaderComponent>
                <div class="card" style="background-color: #f2e8f9;"
                  v-for="orden in current.eventoAgenda.apl_agenda_orden_compra" :key="orden.id">
                  <div class="card-body d-flex justify-content-between align-items-center">
                    <div>
                      <span style="font-size: 18px;">
                        <b>#{{ orden.orden_compra.numero }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin Modal añadir órdenes de compra current.agenda_proveedor -->






    
    <!-- Subcomponentes -->
    <SubirFacturaScanModalComponent :current="seleccionada" @uploaded="refreshAll()" />
    <ReferencialModalComponent :current="seleccionada" />
    <ConsultaArchivoScanSubidoModal :current="seleccionada" />

    <!-- Inicio Modal Correo Preview -->
    <div class="modal fade" id="correoPreviewModal" tabindex="-1" aria-labelledby="correoPreviewModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-5" id="correoPreviewModalLabel">Previsualización del correo a enviarse a los
              contactos del proveedor {{ nombreProveedor }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <CorreoPreviewComponent v-if="current.id && actualizarPreview" @preview-cargada="asignarValorPreviewCargada"
              :obj_id="current.id" :operativo="'RM'" :tienda="current.tienda"></CorreoPreviewComponent>
          </div>
          <div class="modal-footer">
            <button v-if="previewCorreoCargado" type="button" class="btn btn-sm btn-primary"
              @click="notificarContactos">
              Confirmar
            </button>
            <button class="btn btn-sm btn-dark" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin Modal Correo Preview -->

    <!-- MODAL DE ASIGNACION DE ESTACIÓN DE CARGA/DESCARGA -->
    <AsignarEstacionRecepcionModal
      :current="current"
    />

    <!-- MODAL DE ASIGNACION DE ENCARGADO PROVEEDOR -->
    <AsignarEncargadoProveedor
      :current="current"
    />

    <!-- MODAL DE DISCREPANCIA DE UMBRALES (FACTURAS) -->
    <ModalDiscrepanciaUmbrales 
      :discrepancia="discrepancia" 
    />

    <!-- MODAL DE EDITAR/NUEVA FACTURA -->
    <RecepcionFacturaModalComponent
      :recepcion="current"
      :factura_id="id_factura_editar"
      @refresh="refreshAll"
      @close="id_factura_editar = null"
    />

    <!-- MODAL DE ETIQUETA -->
    <RecepcionEtiquetaModalComponent :recepcion="current" @refresh="refreshCurrent" />
    
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import RecepcionService from "@/services/wms/RecepcionService";

// Variable global al módulo para rastrear el estado del modal entre navegaciones internas (Sigue viva hasta recarga de página)
let hasShownModalThisLoad = {};
import RecepcionFacturaEService from "@/services/wms/RecepcionFacturaEService";
import RecepcionFacturaTicketComponent from "@/components/wms/recepcion/RecepcionFacturaTicketComponent";
import RecepcionFacturaDetalleComponent from "@/components/wms/recepcion/RecepcionFacturaDetalleComponent";
import RecepcionEtiquetaModalComponent from "@/components/wms/recepcion/RecepcionEtiquetaModalComponent";
import SubirFacturaScanModalComponent from "@/components/wms/recepcion/SubirFacturaScanModalComponent";
import ReferencialModalComponent from "@/components/wms/recepcion/ReferencialModalComponent";
import ConsultaArchivoScanSubidoModal from "@/components/wms/recepcion/ConsultaArchivoScanSubidoModal";
import LoaderComponent from "@/components/commons/LoaderComponent";
import ContactoProveedorTable from "@/components/cat/proveedores/ContactoProveedorTable";
import CorreoPreviewComponent from "@/components/correos/CorreoPreviewComponent";
import AgendaProveedoresService from "@/services/wms/AgendaProveedoresService";
import OCIndexedDBService from "@/services/wms/OCIndexedDBService";
import { AsignarEstacionRecepcionModal, AsignarEncargadoProveedor, ModalDiscrepanciaUmbrales } from "@/components/atomic";

import AnimatedNumberComponent from "@/components/commons/AnimatedNumberComponent";
import store from "@/store";


import { 
  InputDatePicker, 
  RecepcionFacturaModalComponent 
} from "@/components/atomic";

export default {
  provide() {
    return {
      refreshRecepcion: this.refreshCurrent,
    };
  },
  props: {
    day: {
      type: Number,
    }
  },
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    RecepcionFacturaTicketComponent,
    RecepcionFacturaDetalleComponent,
    RecepcionFacturaModalComponent,
    RecepcionEtiquetaModalComponent,
    SubirFacturaScanModalComponent,
    ReferencialModalComponent,
    ConsultaArchivoScanSubidoModal,
    LoaderComponent,
    ContactoProveedorTable,
    CorreoPreviewComponent,
    AsignarEstacionRecepcionModal,
    AsignarEncargadoProveedor,
    ModalDiscrepanciaUmbrales,
    AnimatedNumberComponent,
    InputDatePicker
  },
  data() {
    return {
      isOpen: false,
      eventoSeleccionado: null,
      agendaProveedor: null,
      eventoAgendadoModal: null,
      isDataLoaded: false,
      agendaEvento: null,
      previewCorreoCargado: false,
      actualizarPreview: false,
      contactos_cargados: false,
      contactos: null,
      contactos_seleccionados: [],
      cards: [],
      estado: "",


      id_factura_editar: null,
      orderCompraNumber: "",
      current: {
        referencia: "",
        id: null,
        estado_str: null,
        tienda: "",
        estado: "A",
        errors: [],
        bultoe_set: [],
        facturae_set: [],
        recepcionetiqueta_set: [],
        finalizado_exito: true,
      },
      needsCleanup: false,
      // Data de Ordenes de Compra
      ordenesCompra: [],
      // Data en Crudo de los detalles de OC
      detalleOrdenesCompraRAW: [],
      // Data de Detalles de OC que se guarda en IndexedDB
      dictOrdenesCompraDtoIDB: [],
      // Data de Detalles de OC que se utiliza para validaciones y/o cálculos
      dictOrdenesCompraD: [],
      // Estado de carga de los detalles de OC
      isDetallesOCCargados: false,
      // Data para el modal de discrepancia de umbrales
      discrepancia: {
        factura: 0,
        conteo: 0,
        diferencia: 0,
        tipo: "",
        umbralFaltante: 0,
        umbralSobrante: 0,
        serie: "",
        documento: "",
        minimo: 0,
        maximo: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      selectedInvoice: 'recepciones/selectedInvoice',
      receiptType: 'recepciones/receiptType',
      barcodeInput: 'recepciones/barcodeInput'
    }),
    tieneArchivos() {
      // Validates if `archivo` or `archivo_2` exists. 
      // It must be a valid non-empty string URL or a File object.
      const hasFile1 = this.seleccionada && this.seleccionada.archivo && 
                      (typeof this.seleccionada.archivo === 'string' ? this.seleccionada.archivo.trim() !== '' : true);
      const hasFile2 = this.seleccionada && this.seleccionada.archivo_2 && 
                      (typeof this.seleccionada.archivo_2 === 'string' ? this.seleccionada.archivo_2.trim() !== '' : true);
      
      return hasFile1 || hasFile2;
    },
    nombreProveedor() {
      return this.current.proveedor_obj ? this.current.proveedor_obj.nombre : "";
    },
    tipo: {
      get() {
        return this.receiptType;
      },
      set(value) {
        this.setReceiptType(value);
      }
    },
    seleccionada: {
      get() {
        return this.selectedInvoice;
      },
      set(value) {
        this.selectInvoice(value);
      }
    },
    facturasFiltradas() {
      if (!this.current || !this.current.facturae_set) return [];
      if (!this.estado) return this.current.facturae_set;
      return this.current.facturae_set.filter(f => f.estado === this.estado);
    },
    isTransporteValidado() {
      const c = this.current;
      if (!c) return false;
      const tieneEncargado = !!(c.encargado_nombre && c.encargado_dpi && c.encargado_matricula);
      const tieneTercerizado = !!c.transporte_tercerizado;
      return tieneEncargado || tieneTercerizado;
    },
    isInvoiceValid() {
      const v = this.getValidationData();
      return v ? v.isValid : true;
    },


    
    

    /**
     * Calcula el total del conteo en el frontend sumando el valor de cada línea
     * (precio_unidad_real * cantidad_total), incluyendo productos en mal estado.
     */ 
    totalConteoFrontend() {
      if (!this.seleccionada || !this.seleccionada.facturad_set) return 0;
      let total = 0;
      this.seleccionada.facturad_set.forEach(linea => {
        let total_linea = 0;
        if (linea.precio_oc > 0) {
          total_linea = (linea.cantidad_total / linea.unidad_medida_obj.cantidad_unidades) * Number(linea.precio_oc);
        } else {
          total_linea = linea.cantidad_total * Number(linea.precio_unidad_real);
        }
        // console.log(linea.producto_obj.nombre, "Cantidad Base:", linea.cantidad_total, "Total Linea:", total_linea);
        console.log(linea)
        total += Number(total_linea || 0);
      });
      return Number(total.toFixed(2));
    }





    /*

    totalConteoFrontend() {
      if (!this.seleccionada || !this.seleccionada.facturad_set) return 0;
      let total = 0;
      this.seleccionada.facturad_set.forEach(linea => {
        // const precio = Number(linea.precio_unidad_real) || 0;
        // const cantidad = Number(linea.cantidad_total) || 0;
        // console.log(linea.cantidad_total, linea.unidad_medida_obj.cantidad_unidades, precio_linea);
        // console.log(linea.producto_obj.nombre,(linea.cantidad_total/linea.unidad_medida_obj.cantidad_unidades)*precio_linea);
        // total2 = Number(current.cantidad_total)
        // total += Number(linea.precio_real || 0);
        // total += precio * cantidad; 
        let precio_linea = linea.precio_oc > 0 ? Number(linea.precio_oc) : Number(linea.precio_unidad_real);
        let total_linea = (linea.cantidad_total/linea.unidad_medida_obj.cantidad_unidades)*precio_linea;

        console.log(linea.producto_obj.nombre, linea.cantidad_total, linea.unidad_medida_obj.cantidad_unidades, precio_linea, total_linea)

        total += Number(total_linea || 0);
      });
      return Number(total.toFixed(2));
    }
     
    */
    



  },
  watch: {
    current: {
      handler(newValue) {
        this.syncRecepcionIDB(newValue);
      },
      deep: true,
      immediate: true
    },
    detalleOrdenesCompraRAW: {
      /**
       * Sincronización de Data de Detalles de OC hacia IndexedDB
       */
      handler(newValue) {
        if (this.current.id && newValue && newValue.length > 0) {
          OCIndexedDBService.mapAndSaveRawDetails(this.current.id, newValue).then((mappedData) => {
            this.dictOrdenesCompraDtoIDB = mappedData;
            console.log("IDB Sincronizado correctamente desde el Watcher");
          });
        }
      },
      deep: true
    },
    dictOrdenesCompraDtoIDB: {
      /**
       * Seteo de Data necesaria para validaciones y/o cálculos en IndexedDB
       */
      handler(newValue) {
        if (this.current.id && newValue && newValue.length > 0) {
          this.dictOrdenesCompraD = newValue;
          OCIndexedDBService.saveDetails(this.current.id, newValue);
        }
      },
      deep: true
    },
    dictOrdenesCompraD: {
      handler(newValue) {
        console.log("OrdenCompraD SETTED: ", newValue);
      },
      deep: true
    },




  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent(true);
    }
    if (self.seleccionada && self.seleccionada.id) {
      self.refreshFacturaE(self.seleccionada.id);
    }
  },
  methods: {
    ...mapActions({
      selectInvoice: 'recepciones/selectInvoice',
      setReceiptType: 'recepciones/setReceiptType',
      setBarcodeInput: 'recepciones/setBarcodeInput',
      clearInvoiceState: 'recepciones/clearInvoiceState'
    }),

    estadoOrden(orden){
      if(orden.vencida) return 'Vencida'
      if(orden.estado === '9') return 'Anulada'
      if(orden.estado === 'B') return 'Disponible'
      if(orden.estado === 'C') return 'De Baja'
      if(orden.estado === 'D' && !orden.vencida) return 'Finalizada'
    },
    syncRecepcionIDB(newValue) {
      if (!newValue || !newValue.id) return;
      this.agendaProveedor = newValue.agenda_proveedor;
      this.agendaEvento = newValue.eventoAgenda;
      this.eventoAgendadoModal = newValue.eventoAgenda;
      /**
       * Seteo del id de recepcion en localStorage
       * Se actualiza siempre para evitar datos estancados al cambiar de registro.
       */
      localStorage.setItem("id_recepcion", JSON.stringify(newValue.id));

      /**
       * Se borran los detalles de las recepciones antiguas
       * que no sean la recepcion con id actual.
       */
      OCIndexedDBService.clearOthers(newValue.id).then(() => {
        /**
         * Se obtienen los detalles de la recepcion actual
         * desde IndexedDB, si no existen se obtienen desde
         * el Backend y se Setean en IndexedDB.<>
         */
        OCIndexedDBService.getDetails(newValue.id).then((details) => {
          if (details) {
            this.dictOrdenesCompraD = details;
            console.log("Detalle de Ordenes de Compra Obtenidos de IndexedDB");
          } else {
            this.fetchDetallesOC(newValue.id);
          }
        });
      });
      /**
       * Modal de Datos del Encargado (Recordatorio si no hay datos)
       */
      const tieneEncargado = !!(newValue.encargado_nombre && newValue.encargado_dpi && newValue.encargado_matricula);
      const tieneTercerizado = !!newValue.transporte_tercerizado;

      if (
        newValue.estacion_descarga == null && 
        !this.seleccionada && 
        !tieneEncargado && !tieneTercerizado
      ) {
        this.abrirModalAsignarEncargadoProveedor();
      }
    },

    /**
     * Obtiene todos los detalles de la recepcion actual desde el Backend
     * para ser seteados en el IndexedDB
     */
    fetchDetallesOC(recepcionId) {
      this.isDetallesOCCargados = false;
      RecepcionService.obtenerDetalleOrdenCompra(recepcionId).then((res) => {
        if (res.data && res.data.length > 0) {
          this.detalleOrdenesCompraRAW = res.data;
          OCIndexedDBService.deleteDetails(recepcionId).then(() => {
            OCIndexedDBService.mapAndSaveRawDetails(recepcionId, res.data).then((mappedData) => {
              this.dictOrdenesCompraDtoIDB = mappedData;
              this.isDetallesOCCargados = true;
              if (!hasShownModalThisLoad[recepcionId]) {
                this.fetchDetallesOCLoaded();
                hasShownModalThisLoad[recepcionId] = true;
              }
              console.log("Detalle de Ordenes de Compra Obtenidos de la API y Seteados en IDB");
            });
          });
        }
      }).catch((err) => {
        this.isDetallesOCCargados = false;
        console.error("Error al obtener los detalles de las OC:", err);
      });
    },
    
    /**
     * Botón de Acción para Refrescar los detalles de las OC
     * para casos de modificacion de OC
     */
    clickRefetchDetallesOC() {
      let recepcionId = this.current.id;
      if (!recepcionId) {
        recepcionId = localStorage.getItem("id_recepcion");
      }
      this.isDetallesOCCargados = false;
      RecepcionService.obtenerDetalleOrdenCompra(recepcionId).then((res) => {
        if (res.data && res.data.length > 0) {
          this.detalleOrdenesCompraRAW = res.data;
          OCIndexedDBService.deleteDetails(recepcionId).then(() => {
            OCIndexedDBService.mapAndSaveRawDetails(recepcionId, res.data).then((mappedData) => {
              this.dictOrdenesCompraDtoIDB = mappedData;
              this.isDetallesOCCargados = true;
              this.fetchDetallesOCLoaded();
              console.log("Detalle de Ordenes de Compra Obtenidos de la API y Seteados en IDB");
            });
          });
        }
      }).catch((err) => {
        this.isDetallesOCCargados = false;
        console.error("Error al obtener los detalles de las OC:", err);
      });
    },

    fetchDetallesOCLoaded() {
      Notifications.alert.success("Ordenes de Compra cargadas", "Puede continuar con el proceso de recepción.");
    },

    handleAgregarFactura() {
      if (!this.isTransporteValidado) {
        Notifications.alert.info("Falta Información", "Debe asignar el encargado del proveedor o el transporte tercerizado antes de agregar facturas.");
        this.abrirModalAsignarEncargadoProveedor();
      } else {
        this.id_factura_editar = null;
        $("#modalFactura").modal("show");
      }
    },

    abrirModalAsignarEncargadoProveedor() {
      $("#modalAsignarEncargadoProveedor").modal("show");
    },
    abrirModalAsignarEstacion() {
      $("#modalAsignarEstacion").modal("show");
    },
    resolveRouteOC(name, params) {
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: { id: params.id }, 
          query: { backToReception: params.backToReception }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: { id: params.id },
          query: { backToReception: params.backToReception }
        });
      }
    },

    /**
     * Método que nos sirve para limitar el ingreso de characteres de tipo texto
     * al input de busqueda de Orden de Compra.
     */
    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    añadirOrdenCompra() {
      let self = this;
      self.eventoSeleccionado = self.agendaProveedor;
      $("#modalAddOC").modal("show");
    },
    cancelAddOC() {
      $("#modalAddOC").modal("hide");
    },

    /**
     * Método que nos obtiene una busqueda de Orden de Compra, según el número
     * enviado como paraámetro de búsqueda, desde el modal de "Agregar OC".
     */
    buscarOrdenCompra() {
      if (this.orderCompraNumber.trim() === "") {
        Notifications.alert.error("Ingrese un número de orden de compra válida.");
        return;
      }

      DynamicService.fetch("compras", "orden_compra_e", { numero: this.orderCompraNumber })
        .then((response) => {
          if (response.data.results && response.data.results.length > 0) {
            let filtroAgenda = response.data.results;
            let agendasActivas = filtroAgenda.filter((orden) => orden.estado === "B");
            if (agendasActivas.length === 0) {
              Notifications.alert.warning("No se encontraron órdenes de compra activas", "Intenta con otro número.");
            } else {
              this.ordenesCompra = agendasActivas;
            }
          } else {
            this.ordenesCompra = [];
            Notifications.alert.warning("No se encontraron órdenes de compra", "Intenta con otro número.");
          }
        })
        .catch((error) => {
          Notifications.alert.error("Error al buscar la orden de compra", error.response);
        });
    },

    /**
     * Se dispara cuando la modal de Factura emite el evento @refresh.
     * Refresca el estado actual Y fuerza la sincronización de detalles de OC
     * en IndexedDB, garantizando que los datos estén disponibles para el componente
     * de recepción de producto aunque el sync inicial al montar haya fallado.
     */
    async updateDetallesOCIndexedDB() {
      if (this.current && this.current.id) {
        await this.fetchDetallesOC(this.current.id);
      }
    },

    
    refreshCurrent(isInitialMount = false) {
      let self = this;
      let keyLS = "isInitialMount_" + this.$route.params.id;
      let isInitialMountLS = localStorage.getItem(keyLS);

      RecepcionService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        
        if (!isInitialMountLS && (this.current && this.current.id) && (this.current.estado == 'A')|| this.current.estado == 'C') {
          this.updateDetallesOCIndexedDB();
          localStorage.setItem(keyLS, "true");
        } else if (isInitialMountLS && (this.current && this.current.id) && (this.current.estado == 'A')) {
          this.isDetallesOCCargados = true;
          if (isInitialMount && !hasShownModalThisLoad[this.$route.params.id]) {
            this.fetchDetallesOCLoaded();
            hasShownModalThisLoad[this.$route.params.id] = true;
          }
        }

        if (self.needsCleanup) {
          self.limpiarLocalStorageProductos();
          self.needsCleanup = false;
        }

        if (self.current.agenda_proveedor) {
          AgendaProveedoresService.getById(self.current.agenda_proveedor)
          .then((response) => {
            self.current.eventoAgenda = response.data;
            self.isDataLoaded = true;
            if (self.current.eventoAgenda && Array.isArray(self.current.eventoAgenda.apl_agenda_orden_compra)) {
              self.cards = self.current.eventoAgenda.apl_agenda_orden_compra.map((card) => ({
                ...card,
              }));
            } else {
              self.cards = [];
            }
          })
          .catch((error) => {
            self.isDataLoaded = false;
            Notifications.alert.error("No se ha podido realizar la acción", error.response);
          });
        } else {
          self.isDataLoaded = true;
          self.cards = [];
        }
        
      });
    },

    async agregarOrdenCompra(orden) {
      let self = this;
      await DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.current.agenda_proveedor,
        "agregar_orden_de_compra",
        {
          id: orden.id,
        }
      ).then((response) => {
        Notifications.toast.success("Orden de compra", "Se añadió correctamente.");
        self.isDataLoaded = false;
        self.orderCompraNumber = "";
        self.ordenesCompra = [];
        self.fetchDetallesOC(self.current.id);
        self.refreshCurrent();
      })
        .catch((error) => {
          if (error.response.data.detail) {
            Notifications.toast.error("Error al agregar la orden de compra", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },


    /**
     * ACTUALMENTE SIN USO, PERO DESCONOZCO SI SE NECESITARA USAR EN EL FUTURO
     * ASÍ QUE HE DECIDIDO DEJARLA EN ESTE LUGAR
     */
    eliminarOrdenCompra(orden) {
      let self = this;
      if (!self.current.eventoAgenda || !self.current.eventoAgenda.id) {
        Notifications.alert.error("No se puede eliminar la orden: no hay evento asociado");
        return;
      }
      DynamicService.postAction(
        "wms",
        "agenda-proveedores",
        self.current.eventoAgenda.id,
        "eliminar_orden_de_compra",
        {
          id: orden.orden_compra.id,
        }
      ).then((response) => {
        self.fetchDetallesOC(self.current.id);
        self.refreshCurrent();
        Notifications.toast.success("¡Éxito!", "Se eliminó la orden de compra.");
      })
        .catch((error) => {
          if (error.response.data.detail) {Notifications.alert.success("Notificar contactos", "Se ha notificado a los correos: " + seleccionados);
            Notifications.toast.error("No se pudo eliminar la orden de compra", error.response.data.detail);
          } else {
            self.current.errors = error.response.data;
          }
        });
    },

    /**
     * ACTUALMENTE SIN USO, PERO DESCONOZCO SI SE NECESITARA USAR EN EL FUTURO
     * ASÍ QUE HE DECIDIDO DEJARLA EN ESTE LUGAR
     */
    duplicarAnularRecepcion() {
      let self = this;
      Notifications.alert.confirm(
        "Duplicar y Anular Recepción",
        "Por favor tomar en cuenta que se anulara la recepción, y se duplicara con estado abierto para su corrección y posterior finalización",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion",
            self.current.id,
            "anular_duplicar_recepcion"
          )
            .then((response) => {
              let id = response.data;
              Notifications.alert.success(
                "Duplicar y Anular Recepción",
                "Realizado Exitosamente",
                ""
              );
              self.$router.push({
                name: "wms-recepcion-editar",
                params: { id: id },
              });
              self.refreshCurrent();
              self.deseleccionar();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Duplicar y Anular Recepción",
                error.response.data.detail
              );
            });
        }
      );
    },
    openModalEditarFact() {
      this.id_factura_editar = this.seleccionada.id;
      $("#modalFactura").modal("show");
    },

    refreshAll() {
      let self = this;
      self.refreshCurrent();
      if (self.seleccionada && self.seleccionada.id) {
        self.refreshFacturaE(self.seleccionada.id);
      }
    },

    clickSincronizarPreciosOC() {
      let self = this;
      if (!this.seleccionada || !this.seleccionada.id) return;

      Notifications.alert.confirm(
        "Actualizar Precios de Factura",
        "¿Está seguro que desea actualizar los precios de los productos escaneados con los precios actuales de la Orden de Compra? Esta acción no se puede deshacer.",
        "Actualizar",
        function () {
          RecepcionFacturaEService.sincronizarPreciosOC(self.seleccionada.id)
            .then((response) => {
              let msg = "Los precios se han sincronizado correctamente.";
              if (response.data.skus_eliminados && response.data.skus_eliminados.length > 0) {
                msg += ` Se eliminaron las líneas de la factura para los siguientes SKUs (OC anulada): ${response.data.skus_eliminados.join(", ")}`;
              }
              Notifications.alert.success(
                "Sincronización de Precios",
                msg
              );
              self.refreshAll();
            })
            .catch((error) => {
              const msg =
                error.response && error.response.data && error.response.data.detail
                  ? error.response.data.detail
                  : "Ha ocurrido un error al sincronizar los precios.";
              Notifications.alert.error("Sincronización de Precios", msg);
            });
        }
      );
    },

    reporteDevolucion(current) {
      let self = this;
      self.recepcion = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/compras_locales/ingreso2.jrxml&id=${self.recepcion}`
      );
    },
    reporteDevolucionMedia(current) {
      let self = this;
      self.recepcion = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/compras_locales/ingreso.jrxml&id=${self.recepcion}`
      );
    },
    reporteDiferencia(current) {
      let self = this;
      self.recepcion = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/diferencia_precio/diferencia_precio_subreport.jrxml&id=${self.recepcion}`
      );
    },

    
    refreshContactosNotificacion() {
      let self = this;
      // Datos para los contactos a notificar o notificados
      const recepcion = self.current.id;
      const tienda = self.current.tienda;
      const operativo = 'RM' // Es el operativo para Recepción de Mercancias (RM)

      // Obtener contactos a notificar por operativo

      DynamicService.postAction("cat", "proveedores", self.current.proveedor, "contactos_por_operativo", {
        tienda: tienda,
        obj_id: recepcion,
        operativo: operativo
      })
        .then(response => {
          self.contactos = response.data;
          self.contactos_cargados = true;
        })
    },
    notificarContactos() {
      let self = this;
      // Se obtiene los contactos seleccionados por la property Name
      let seleccionados = [];
      let seleccionados_input = Array.from(document.getElementsByName("contactos_seleccionados"));
      self.contactos_seleccionados = seleccionados_input.filter(contactos => contactos.checked);
      if (self.contactos_seleccionados.length === 0) {
        this.$toast.warning("No se ha seleccionado ningún contacto", "Aviso", { position: 'topRight' });
        return;
      };
      self.contactos_seleccionados.forEach(contacto => {
        seleccionados.push(contacto._value);
      });
      // Se envía la notificación a los contactos seleccionados
      let params = {
        contactos: seleccionados,
      };
      DynamicService.postAction("wms", "recepcion", self.current.id, "notificar_recepcion", params)
        .then((res) => {
          Notifications.alert.success("Notificar contactos", "Se ha notificado a los correos: " + seleccionados);
          self.refreshContactosNotificacion();
          $("#correoPreviewModal").modal("hide");
        })
        .catch((error) => {
          if (error.response.data) {
            Notifications.alert.error("Notificar contactos", error.response.data);
            console.error(error.response.data);
          }
        });
    },
    refreshFacturaE(facturae_id) {
      let self = this;
      RecepcionFacturaEService.getById(facturae_id).then((response) => {
        self.seleccionada = response.data;
      });
    },
    refreshAll() {
      this.refreshCurrent();
      this.refreshFacturaE(this.seleccionada.id);
    },
    deseleccionar() {
      this.clearInvoiceState();
      this.refreshCurrent();
    },
    seleccionar(facturae_id) {
      this.refreshFacturaE(facturae_id);
    },

    getValidationData() {
      if (!this.seleccionada) return null;

      const cleanNum = (val) => {
        if (typeof val === "number") return val;
        if (!val) return 0;
        return parseFloat(val.toString().replace(/[Q$,\s]/g, "")) || 0;
      };

      // Asegurar precisión decimal eliminando formatos de texto (comas, símbolos)
      const totalFactura = Number(cleanNum(this.seleccionada.total_documento).toFixed(2));
      const totalConteo = this.totalConteoFrontend;
      
      // Priorizar proveedor de la factura, luego de la recepción
      const proveedor = this.seleccionada.proveedor_obj || this.current.proveedor_obj || {};
      
      const umbralSobrante = Number(proveedor.fact_umbral_sobrante !== undefined && proveedor.fact_umbral_sobrante !== null ? proveedor.fact_umbral_sobrante : 0.05);
      const umbralFaltante = Number(proveedor.fact_umbral_faltante !== undefined && proveedor.fact_umbral_faltante !== null ? proveedor.fact_umbral_faltante : -0.05);
      
      // Si los montos redondeados al centavo son idénticos, es válido sin importar los umbrales
      if (totalFactura === totalConteo) {
        return {
          isValid: true,
          data: {
            factura: totalFactura,
            conteo: totalConteo,
            diferencia: 0,
            tipo: "Exacto",
            umbralFaltante: umbralFaltante,
            umbralSobrante: umbralSobrante,
            serie: this.seleccionada.serie || "",
            documento: this.seleccionada.documento || "",
            minimo: totalFactura,
            maximo: totalFactura
          }
        };
      }

      const limiteInferior = totalFactura + (totalFactura * umbralFaltante);
      const limiteSuperior = totalFactura + (totalFactura * umbralSobrante);
      
      // Usar redondeo a 2 decimales para la comparación final de límites
      const inferiorRedondeado = Number(limiteInferior.toFixed(2));
      const superiorRedondeado = Number(limiteSuperior.toFixed(2));

      const isValid = (totalConteo >= inferiorRedondeado && totalConteo <= superiorRedondeado);

      return {
        isValid: isValid,
        data: {
          factura: totalFactura,
          conteo: totalConteo,
          diferencia: totalConteo - totalFactura,
          tipo: (totalConteo - totalFactura) > 0 ? "Sobrante" : "Faltante",
          umbralFaltante: umbralFaltante,
          umbralSobrante: umbralSobrante,
          serie: this.seleccionada.serie || "",
          documento: this.seleccionada.documento || "",
          minimo: inferiorRedondeado,
          maximo: superiorRedondeado
        }
      };
    },



    /**
     * Valida la integridad de las Unidades de Medida entre las lineas de recepcion y la OC en IndexedDB.
     * @param {Array} facturasIds  Array de IDs de factura a validar. Para cerrarFactura pasa [facturaId], para finalizarRecepcion pasa todos los IDs.
     * @param {Array} details      Detalle plano de la OC ya sincronizado con IndexedDB.
     * @param {Boolean} showDocumento  Si true, la key incluye el numero de documento de la factura (para finalizarRecepcion).
     * @returns {Boolean} true si hay discrepancias (se muestra el modal y se debe detener). false si todo esta OK.
     */
    async _validarIntegridadUM(facturasIds, details, showDocumento = false) {
      let mismatchedSKUs = new Map();

      let promesas = facturasIds.map(id => RecepcionFacturaEService.getById(id));
      let respuestas = await Promise.all(promesas);

      respuestas.forEach(resp => {
        let facturaDetallada = resp.data;
        if (!facturaDetallada.facturad_set) return;

        facturaDetallada.facturad_set.forEach(linea => {
          if (!linea.producto_obj || !linea.producto_obj.sku || !linea.unidad_medida) return;

          let matchingIdbDetails = details.filter(d => {
            let skuMatch = d.sku === linea.producto_obj.sku;
            if (skuMatch && linea.orden_compra_d && linea.orden_compra_d.id) {
              let lineaOcId = linea.orden_compra_d.id.replace(/-/g, '');
              return d.detalle_oc_id === lineaOcId;
            }
            return skuMatch;
          });

          if (matchingIdbDetails.length === 0) return;

          let validUmIds = matchingIdbDetails.map(d =>
            typeof d.unidad_medida === 'object' ? d.unidad_medida.id : d.unidad_medida
          );
          let currentUmId = linea.unidad_medida;

          if (!validUmIds.some(id => String(id) === String(currentUmId))) {
            let sku = linea.producto_obj.sku;
            let key = showDocumento
              ? `${facturaDetallada.documento || 'Sin #'} <br> ${sku}`
              : sku;
            let umRecepcion = linea.unidad_medida_obj ? linea.unidad_medida_obj.nombre : currentUmId;
            let validUmNames = matchingIdbDetails.map(d =>
              typeof d.unidad_medida === 'object' ? d.unidad_medida.nombre : d.unidad_medida
            ).join(']|[');

            if (!mismatchedSKUs.has(key)) {
              mismatchedSKUs.set(key, { sku: key, umRecepcion, umOc: validUmNames });
            }
          }
        });
      });

      if (mismatchedSKUs.size > 0) {
        let colHeader = showDocumento ? 'Factura - SKU' : 'SKU';
        let rows = Array.from(mismatchedSKUs.values()).map(item =>
          `<tr><td>${item.sku}</td><td>${item.umRecepcion}</td><td>${item.umOc}</td></tr>`
        ).join('');

        let htmlTable = `
          <div class="table-responsive mt-3">
            <table class="table table-bordered table-sm text-left" style="font-size: 0.9em;">
              <thead class="bg-light">
                <tr>
                  <th>${colHeader}</th>
                  <th>UM Recepción</th>
                  <th>UM OC</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
          </div>
        `;
        let wrapper = document.createElement('div');
        wrapper.innerHTML = htmlTable;
        swal({
          title: "Error de Integridad de UM",
          text: "Las siguientes unidades de medida no coinciden",
          content: wrapper,
          icon: "error",
          dangerMode: true,
        });
        return true;
      }
      return false;
    },




    async cerrarFactura() {
      let self = this;
      
      // -- INICIO VALIDACION UMBRALES --
      const v = this.getValidationData();
      if (v && !v.isValid) {
        this.discrepancia = v.data;
        $("#modalDiscrepanciaUmbrales").modal("show");
        return;
      }
      // -- FIN VALIDACION UMBRALES --

      // Validacion de Integridad de Unidad de Medida vs API
      try {
        let res = await RecepcionService.obtenerDetalleOrdenCompra(self.current.id);
        if (res && res.data && res.data.length > 0) {
          self.detalleOrdenesCompraRAW = res.data;
          await OCIndexedDBService.deleteDetails(self.current.id);
          let details = await OCIndexedDBService.mapAndSaveRawDetails(self.current.id, res.data);
          self.dictOrdenesCompraDtoIDB = details;
          self.isDetallesOCCargados = true;

          if (details) {
            let hayError = await self._validarIntegridadUM([self.seleccionada.id], details, false);
            if (hayError) return;
          }
        }
      } catch (e) {
        console.error("Error al obtener/validar detalles de OC desde la API:", e);
      }

      DynamicService.postAction("wms", "facturas", self.seleccionada.id, "cerrar", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Cerrar facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
    },


    async finalizarRecepcion() {
      let self = this;
      // Capturamos el ID antes de cualquier await para evitar bugs de closure reactivo
      let recepcionId = self.current.id;
      let fecha_proceso = localStorage.getItem("fecha_proceso");
      fecha_proceso = new Date(fecha_proceso);
      if (fecha_proceso) {
        fecha_proceso.setSeconds(fecha_proceso.getSeconds() + 45);
        if (fecha_proceso > new Date()) {
          let tiempo_espera = fecha_proceso - new Date();
          tiempo_espera = Math.floor(tiempo_espera / 1000);
          Notifications.alert.error(
            "Finalizar Recepción",
            "Este proceso solo se puede ejecutar una vez cada 45 seg, faltan  " +
            tiempo_espera +
            " seg. para el proximo intento"
          );
          self.refreshCurrent();
          return;
        }
      }
      // Validacion de Integridad de Unidad de Medida vs API (actualiza Indexed DB silenciosamente)
      try {
        let res = await RecepcionService.obtenerDetalleOrdenCompra(recepcionId);
        if (res && res.data && res.data.length > 0) {
          self.detalleOrdenesCompraRAW = res.data;
          await OCIndexedDBService.deleteDetails(recepcionId);
          let details = await OCIndexedDBService.mapAndSaveRawDetails(recepcionId, res.data);
          self.dictOrdenesCompraDtoIDB = details;
          self.isDetallesOCCargados = true;

          if (details && self.current.facturae_set && self.current.facturae_set.length > 0) {
            let facturasIds = self.current.facturae_set.map(f => f.id);
            let hayError = await self._validarIntegridadUM(facturasIds, details, true);
            if (hayError) return;
          }
        }
      } catch (e) {
        console.error("Error al obtener/validar detalles de OC desde la API:", e);
      }
      Notifications.alert.confirm(
        "Finalizar Recepción de Productos",
        "¿Desea finalizar la recepción de productos, no podrá realizar ninguna modificacion luego de realizar esta acción?",
        "Si Finalizar",
        function () {
          console.log("[finalizarRecepcion] Usando recepcionId:", recepcionId);
          localStorage.setItem("fecha_proceso", new Date());
          DynamicService.postAction(
            "wms",
            "recepcion",
            recepcionId,
            "finalizar_recepcion",
            {}
          )
            .then((res) => {
              self.refreshCurrent();
              self.limpiarEstadoRecepcion();

              Notifications.toast.success(
                "Finalizar Recepción",
                "Realizado correctamente"
              );
            })
            .catch((error) => {              
              localStorage.removeItem("fecha_proceso");
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Finalizar Recepción",
                  error.response.data.detail
                );
                self.finalizado_exito=false
              } else {
                let erorrs = "";
                error.response.data.map(function (value, key) {
                  erorrs += value;
                });
                Notifications.alert.error("Finalizar Recepción", erorrs);
              }
            });
        }
      );
    },

    

    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Anular Factura",
        "¿Esta seguro de anular la factura?",
        "Si Anular",
        function(){
          DynamicService.postAction("wms", "facturas", self.seleccionada.id, "anular", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Anular facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
        }
      )
    },
    abrirFactura() {
      let self = this;
      DynamicService.postAction("wms", "facturas", self.seleccionada.id, "abrir", {})
        .then((res) => {
          self.refreshCurrent();
          self.refreshFacturaE(self.seleccionada.id);
          Notifications.toast.success("Abrir facturar", "Realizado correctamente");
        })
        .catch((error) => {
          Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
        });
    },









    
    
    verContactos() {
      let routeUrl = this.$router.resolve({
        name: "cat-contacto-proveedor-nuevo",
        params: { id_proveedor: this.current.proveedor },
      });
      window.open(routeUrl.href, "_blank");
    },
    vistaPreviaCorreo() {
      let self = this;
      self.actualizarPreview = false;
      DynamicService.postAction("wms", "recepcion", self.current.id, "crear_actualizar_correo")
        .then((res) => {
          self.actualizarPreview = true;
          $("#correoPreviewModal").modal("show");
        }).catch((err) => {
          self.actualizarPreview = false;
          if (err.response.data) {
            console.error(err.response.data);
          }
        });
    },
    asignarValorPreviewCargada(valor) {
      this.previewCorreoCargado = valor;
    },
    limpiarEstadoRecepcion() {
      this.clearInvoiceState();
      this.limpiarLocalStorageProductos();
      // Eliminar claves globales que no se limpiaban antes
      localStorage.removeItem("id_recepcion");
      localStorage.removeItem("fecha_proceso");
      if (this.current && this.current.id) {
        localStorage.removeItem("isInitialMount_" + this.current.id);
      }
      // Borrar los datos de esta recepción en IndexedDB
      if (this.current && this.current.id) {
        OCIndexedDBService.deleteDetails(this.current.id).catch(() => {});
      }
    },
    limpiarLocalStorageProductos() {
      if (this.current.facturae_set) {
        const facturaIds = this.current.facturae_set.map((f) => f.id);
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith("recepcion-producto-")) {
            if (facturaIds.some((id) => key.includes(id))) {
              keysToRemove.push(key);
            }
          }
        }
        keysToRemove.forEach((k) => localStorage.removeItem(k));
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    const isRelatedRoute = from.name === "RecepcionAgregarProductoDetalle";

    if (!isRelatedRoute) {
      store.dispatch("recepciones/clearInvoiceState");
    }

    next((vm) => {
      if (!isRelatedRoute) {
        vm.needsCleanup = true;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    const isRelatedRoute = to.name === "RecepcionAgregarProductoDetalle";

    if (!isRelatedRoute) {
      this.limpiarEstadoRecepcion();
    }
    next();
  },
};
</script>
<style scoped>
.custom-input {
  border: 1px solid #89898995;
  border-radius: 25px !important;
  padding: 12px 15px !important;
  height: auto !important;
  text-align: center;
  background-color: transparent !important;
  color: #45505e !important;
}

.support-index.full-layout-content .support-tickets {
  display: none !important;
}
.support-index.full-layout-content .support-ticket-content-w {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  display: block;
}

.custom-input input::placeholder {
  color: #4d5968 !important;
  font-size: 13px !important;
  opacity: 1;
}
.custom-input >>> .vs__dropdown-toggle {
  border: none !important;
}
.custom-input >>> .vs__search {
  text-align: center !important;
  color: #546171 !important;
  font-size: 13px;
}
.custom-input >>> .vs__selected {
  text-align: center !important;
}
.radius_custom {
  border-radius: 25px !important;
  padding: 12px 20px !important;
}
.radius_custom_green {
  border: 1px solid #0c9d2e !important;
  background-color: #0c9d2e00 !important;
  border-radius: 25px !important;
}
.radius_custom_green:hover {
  border: 1px solid #0c9d2e !important;
  background-color: #0c9d2e !important;
  color: #fff !important;
  border-radius: 25px !important;
}
.radius_custom_blue {
  border: 1px solid #007bff !important;
  background-color: rgba(0, 123, 255, 0) !important;
  border-radius: 25px !important;
}
.radius_custom_blue:hover {
  border: 1px solid #007bff !important;
  background-color: #007bff !important;
  color: #fff !important;
  border-radius: 25px !important;
}
.border_panel_green {
  border-left: 10px solid #23b014;
}
.border_panel_red {
  border-left: 10px solid #c21a1a;
}
.border_panel_blue {
  border-left: 10px solid #007bff;
}
</style>
<style>
  .support-index .st-body .ticket-content .ticket-description{
    height: auto;
  }
  .decorator {
    text-decoration: none !important;
    font-size: 16pt;
    font-weight: bold;
  }

  /* Animaciones Pulse para Badges */
  .badge.pulse-blue {
    animation: pulse-badge-blue 1.5s infinite;
  }
  @keyframes pulse-badge-blue {
    0% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(0, 123, 255, 0); }
    100% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0); }
  }

  .badge.pulse-red {
    animation: pulse-badge-red 1.5s infinite;
  }
  @keyframes pulse-badge-red {
    0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(220, 53, 69, 0); }
    100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
  }

  .badge.pulse-green {
    animation: pulse-badge-green 1.5s infinite;
  }
  @keyframes pulse-badge-green {
    0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(40, 167, 69, 0); }
    100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
  }

  .badge.pulse-secondary {
    animation: pulse-badge-secondary 1.5s infinite;
  }
  @keyframes pulse-badge-secondary {
    0% { box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(108, 117, 125, 0); }
    100% { box-shadow: 0 0 0 0 rgba(108, 117, 125, 0); }
  }

  .badge.pulse-dark {
    animation: pulse-badge-dark 1.5s infinite;
  }
  @keyframes pulse-badge-dark {
    0% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.8); }
    70% { box-shadow: 0 0 0 8px rgba(52, 58, 64, 0); }
    100% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0); }
  }
</style>